import Home from '@/views/home/Home.vue'
import Splash from '@/views/home/Splash.vue'
import Detail from '@/views/home/Detail.vue'

import YcHome from '@/views/home/YcHome.vue'
import DetailOne from '@/views/home/DetailOne.vue'
import DetailTwo from '@/views/home/DetailTwo.vue'
import YmHome from '@/views/home/YmHome.vue'
import YcHomeList from '@/views/home/YcHomeList.vue'

import Donation from '@/views/donation/Donation.vue'
import DonationDetail from '@/views/donation/Detail.vue'

export default [
    {
        // 首页
        path: '/',
        redirect: '/home'
    },
    {
        // 启动页
        path: '/splash',
        name: 'Splash',
        component: Splash
    },
    {
        // 首页
        path: '/home',
        name: 'Home',
        component: Home
    },
    {
        // 联系我们
        path: '/contact',
        name: 'Contact',
        component: () => import('@/views/home/Contact')
    },
    {
        // 详情
        path: '/home/detail',
        name: 'Details',
        component: Detail
    },
    {
        // 颍川首页列表
        path: '/ychome',
        name: 'YcHome',
        component: YcHome
    },
    {
        // 详情一
        path: '/ychome/detail',
        name: 'DetailOne',
        component: DetailOne
    },
    {
        // 颍川列表
        path: '/ychomelist',
        name: 'YcHomeList',
        component: YcHomeList
    },
    {
        // 详情二
        path: '/ychomelist/detail',
        name: 'DetailTwo',
        component: DetailTwo
    },
    {
        // 义门列表
        path: '/ymhome',
        name: 'YmHome',
        component: YmHome
    },
    {
        // 捐赠列表
        path: '/donation',
        name: 'Donation',
        component: Donation
    },
    {
        // 捐赠详情
        path: '/donation/detail',
        name: 'DonationDetail',
        component: DonationDetail
    },
    {
        // 查谱视频教程
        path: '/video/detail',
        name: 'DetailVideo',
        component: () => import('@/views/home/DetailVideo')
    },
    {
        // 查谱文档教程
        path: '/doc/detail',
        name: 'DetailDoc',
        component: () => import('@/views/home/DetailDoc')
    }
]
